import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { TaxColumn } from '/@/modules/tax/models/TaxColumn';

export class TaxLineItem extends BaseModel {
  label: string;
  alternativeLabel?: string;
  letterIdentifier?: string;
  isEditable?: boolean;
  column?: TaxColumn;
  lineItems?: TaxLineItem[];

  constructor(model = {}) {
    super();
    this.label = model.label;
    this.alternativeLabel = model.alternativeLabel;
    this.letterIdentifier = model.letterIdentifier;
    this.isEditable = model.isEditable;
    this.column = TaxColumn.mapModel(model.column);
    this.lineItems = TaxLineItem.mapModelsOrNull(model.lineItems);
  }
}
